import React from 'react';
import {
  Router as DefaultRouter,
  Route,
  Switch,
  StaticRouter,
} from 'react-router-dom';
import dynamic from 'umi/dynamic';
import renderRoutes from 'umi/lib/renderRoutes';
import history from '@@/history';
import RendererWrapper0 from '/home/runner/work/1/s/frontend/src/pages/.umi-production/LocaleWrapper.jsx';
import _dvaDynamic from 'dva/dynamic';

const Router = require('dva/router').routerRedux.ConnectedRouter;

const routes = [
  {
    path: '/user',
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () =>
            import(/* webpackChunkName: "layouts__AuthLayout" */ '../../layouts/AuthLayout'),
          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
            .default,
        })
      : require('../../layouts/AuthLayout').default,
    routes: [
      {
        name: 'login',
        path: '/user/login',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__user__login" */ '../user/login'),
              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                .default,
            })
          : require('../user/login').default,
        exact: true,
      },
      {
        name: 'passwordReset',
        path: '/user/password-reset',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__user__passwordReset" */ '../user/passwordReset'),
              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                .default,
            })
          : require('../user/passwordReset').default,
        exact: true,
      },
      {
        name: 'passwordReset',
        path: '/user/password-reset-confirm/:uid/:token/:email',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__user__passwordReset_Confirm" */ '../user/passwordReset_Confirm'),
              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                .default,
            })
          : require('../user/passwordReset_Confirm').default,
        exact: true,
      },
      {
        name: 'signup',
        path: '/user/signup',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__user__signUp" */ '../user/signUp'),
              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                .default,
            })
          : require('../user/signUp').default,
        exact: true,
      },
    ],
  },
  {
    name: '483_download',
    path: '/483_download',
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () =>
            import(/* webpackChunkName: "p__landing__download483" */ '../landing/download483'),
          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
            .default,
        })
      : require('../landing/download483').default,
    exact: true,
  },
  {
    name: 'Terms and Conditions',
    path: '/terms-and-conditions',
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () =>
            import(/* webpackChunkName: "p__landing__termsNconditions" */ '../landing/termsNconditions'),
          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
            .default,
        })
      : require('../landing/termsNconditions').default,
    exact: true,
  },
  {
    name: 'Privacy Policy',
    path: '/privacy-policy',
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () =>
            import(/* webpackChunkName: "p__landing__privacypolicy" */ '../landing/privacypolicy'),
          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
            .default,
        })
      : require('../landing/privacypolicy').default,
    exact: true,
  },
  {
    name: 'Cookie Policy',
    path: '/cookies-tracking-notice',
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () =>
            import(/* webpackChunkName: "p__landing__cookiepolicy" */ '../landing/cookiepolicy'),
          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
            .default,
        })
      : require('../landing/cookiepolicy').default,
    exact: true,
  },
  {
    name: 'form483_viewer',
    path: '/form483/:token',
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () =>
            import(/* webpackChunkName: "p__form483Viewer__index" */ '../form483Viewer/index'),
          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
            .default,
        })
      : require('../form483Viewer/index').default,
    exact: true,
  },
  {
    path: '/',
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () =>
            import(/* webpackChunkName: "layouts__SecurityLayout" */ '../../layouts/SecurityLayout'),
          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
            .default,
        })
      : require('../../layouts/SecurityLayout').default,
    routes: [
      {
        path: '/',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "layouts__BasicLayout" */ '../../layouts/BasicLayout'),
              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                .default,
            })
          : require('../../layouts/BasicLayout').default,
        authority: ['admin', 'user'],
        routes: [
          {
            path: '/',
            redirect: '/inspections',
            exact: true,
          },
          {
            name: 'Data Typing',
            path: '/data_typing',
            icon: 'line-chart',
            authority: ['2222'],
            routes: [
              {
                path: '/data_typing',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__dataTyping__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/dataTyping/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../dataTyping/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../dataTyping/list').default,
                exact: true,
              },
            ],
          },
          {
            name: 'Labelling',
            path: '/labelling',
            icon: 'medicine-box',
            authority: ['88888', '44444'],
            routes: [
              {
                path: '/labelling',
                redirect: '/labelling/usfda',
                exact: true,
              },
              {
                name: 'USFDA',
                path: '/labelling/usfda',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__drugs_at_fda__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/drugs_at_fda/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../drugs_at_fda/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../drugs_at_fda/list').default,
                exact: true,
              },
              {
                path: '/labelling/usfda/:id',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__drugs_at_fda__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/drugs_at_fda/details/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../drugs_at_fda/details'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../drugs_at_fda/details').default,
                exact: true,
                hideInMenu: true,
              },
            ],
          },
          {
            name: 'RxLabel Intelligence',
            path: '/rxlabel-intelligence',
            icon: 'file-search',
            authority: ['88888', '44444'],
            routes: [
              {
                path: '/rxlabel-intelligence',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../labelReader'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../labelReader').default,
                exact: true,
              },
            ],
          },
          {
            name: 'User Management',
            path: '/userManagement',
            icon: 'team',
            authority: ['3333'],
            routes: [
              {
                path: '/userManagement',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__userManagement__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/userManagement/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../userManagement/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../userManagement/list').default,
                exact: true,
              },
            ],
          },
          {
            name: 'weekly_updates',
            path: '/weeklyUpdates',
            icon: 'schedule',
            authority: ['88888', '3333', '7777'],
            routes: [
              {
                path: '/weeklyUpdates',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__weeklyUpdates__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/weeklyUpdates/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../weeklyUpdates/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../weeklyUpdates/list').default,
                exact: true,
              },
            ],
          },
          {
            name: 'Global Site Intelligence',
            path: '/global-site-intelligence',
            icon: 'global',
            authority: ['88888', '3333', '7777'],
            routes: [
              {
                path: '/global-site-intelligence',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__globalSiteIntelligence__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/globalSiteIntelligence/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../globalSiteIntelligence/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../globalSiteIntelligence/list').default,
                exact: true,
              },
            ],
          },
          {
            name: 'USFDA Inspections',
            path: '/inspections',
            icon: 'project',
            authority: ['9999', '1111', '6666', '1', '3333', '7777'],
            routes: [
              {
                path: '/inspections',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__inspections__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/inspections/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../inspections/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../inspections/list').default,
                exact: true,
              },
              {
                path: '/inspections/:id',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__inspections__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/inspections/details/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../inspections/details'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../inspections/details').default,
                exact: true,
              },
            ],
          },
          {
            name: 'Global Agencies Inspections',
            path: '/other_agencies_inspections',
            icon: 'project',
            authority: ['9999', '1111', '6666', '3333', '7777'],
            routes: [
              {
                path: '/other_agencies_inspections',
                redirect: '/other_agencies_inspections/Mhra_Eu_inspection',
                exact: true,
              },
              {
                name: 'MHRA/EU Inspections',
                path: '/other_agencies_inspections/Mhra_Eu_inspection',
                icon: 'project',
                authority: ['9999', '1111', '6666', '3333', '7777'],
                routes: [
                  {
                    path: '/other_agencies_inspections/Mhra_Eu_inspection',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__Mhra_Eu_inspections__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/Mhra_Eu_inspections/list/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../Mhra_Eu_inspections/list'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../Mhra_Eu_inspections/list').default,
                    exact: true,
                  },
                ],
              },
              {
                name: 'PMDA Inspections',
                path: '/other_agencies_inspections/pmda_inspections',
                icon: 'project',
                authority: ['9999', '1111', '3333', '7777'],
                routes: [
                  {
                    path: '/other_agencies_inspections/pmda_inspections',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__pmda_inspections__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/pmda_inspections/list/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../pmda_inspections/list'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../pmda_inspections/list').default,
                    exact: true,
                  },
                ],
              },
              {
                name: 'SwissMedic GMDP',
                path: '/other_agencies_inspections/swiss_gmdp_inspections',
                icon: 'project',
                authority: ['9999', '1111', '3333', '7777'],
                routes: [
                  {
                    path: '/other_agencies_inspections/swiss_gmdp_inspections',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__swiss_gmdp_inspections__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/swiss_gmdp_inspections/list/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../swiss_gmdp_inspections/list'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../swiss_gmdp_inspections/list').default,
                    exact: true,
                  },
                ],
              },
              {
                name: 'Health Canada Inspections',
                path: '/other_agencies_inspections/health_canada_inspections',
                icon: 'project',
                authority: ['9999', '1111', '6666', '3333', '7777'],
                routes: [
                  {
                    path:
                      '/other_agencies_inspections/health_canada_inspections',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__health_canada_inspections__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/health_canada_inspections/list/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../health_canada_inspections/list'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../health_canada_inspections/list').default,
                    exact: true,
                  },
                  {
                    path:
                      '/other_agencies_inspections/health_canada_inspections/:id',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__health_canada_inspections__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/health_canada_inspections/details/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../health_canada_inspections/details'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../health_canada_inspections/details').default,
                    exact: true,
                  },
                ],
              },
              {
                name: 'RRA Inspections',
                path: '/other_agencies_inspections/rra_inspections',
                icon: 'laptop',
                authority: ['1111', '3333', '7777'],
                routes: [
                  {
                    path: '/other_agencies_inspections/rra_inspections',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__rra_inspections__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/rra_inspections/list/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../rra_inspections/list'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../rra_inspections/list').default,
                    exact: true,
                  },
                ],
              },
            ],
          },
          {
            path: '/Mhra_Eu_inspection',
            redirect: '/other_agencies_inspections/Mhra_Eu_inspection',
            exact: true,
          },
          {
            path: '/pmda_inspections',
            redirect: '/other_agencies_inspections/pmda_inspections',
            exact: true,
          },
          {
            path: '/swiss_gmdp_inspections',
            redirect: '/other_agencies_inspections/swiss_gmdp_inspections',
            exact: true,
          },
          {
            path: '/health_canada_inspections',
            redirect: '/other_agencies_inspections/health_canada_inspections',
            exact: true,
          },
          {
            path: '/rra_inspections',
            redirect: '/other_agencies_inspections/rra_inspections',
            exact: true,
          },
          {
            name: 'investigators',
            path: '/investigators',
            icon: 'contacts',
            authority: ['9999', '1111', '6666', '1', '3333', '7777'],
            routes: [
              {
                path: '/investigators',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__investigators__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/investigators/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../investigators/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../investigators/list').default,
                exact: true,
              },
              {
                path: '/investigators/:id',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__investigators__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/investigators/details/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../investigators/details'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../investigators/details').default,
                exact: true,
              },
            ],
          },
          {
            name: 'Response Letters',
            path: '/response_letters',
            icon: 'file-text',
            authority: ['88888'],
            routes: [
              {
                path: '/response_letters',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__response_letters__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/response_letters/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../response_letters/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../response_letters/list').default,
                exact: true,
              },
            ],
          },
          {
            name: 'Trending483',
            path: '/trending_483',
            icon: 'download',
            authority: ['9999', '1111', '6666', '1', '3333', '7777'],
            routes: [
              {
                path: '/trending_483',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__trending_483__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/trending_483/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../trending_483/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../trending_483/list').default,
                exact: true,
              },
            ],
          },
          {
            name: 'Recently Added 483s',
            path: '/recently483',
            icon: 'rise',
            authority: ['9999', '1111', '6666', '3333', '7777'],
            routes: [
              {
                path: '/recently483',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__RecentlyAdded483__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/RecentlyAdded483/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../RecentlyAdded483/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../RecentlyAdded483/list').default,
                exact: true,
              },
            ],
          },
          {
            name: 'Notifications',
            path: '/notifications',
            icon: 'project',
            hideInMenu: true,
            authority: ['9999', '1111', '6666', '3333', '7777'],
            routes: [
              {
                path: '/notifications',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__notifications__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/notifications/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../notifications/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../notifications/list').default,
                exact: true,
              },
            ],
          },
          {
            name: 'Daily Companion',
            path: '/dailyCompanion',
            icon: 'undo',
            hideInMenu: true,
            authority: ['9999', '1111', '6666', '3333', '7777'],
            routes: [
              {
                path: '/dailyCompanion',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__dailyCompanion__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/dailyCompanion/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../dailyCompanion/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../dailyCompanion/list').default,
                exact: true,
              },
              {
                path: '/dailyCompanion/:id',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__dailyCompanion__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/dailyCompanion/details/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../dailyCompanion/details'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../dailyCompanion/details').default,
                exact: true,
              },
            ],
          },
          {
            name: 'Analytics',
            path: '/global_analytics',
            icon: 'line-chart',
            authority: ['9999', '1111', '6666', '3333', '7777', '88888'],
            routes: [
              {
                path: '/global_analytics',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__globalAnalytics__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/globalAnalytics/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../globalAnalytics/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../globalAnalytics/list').default,
                exact: true,
              },
            ],
          },
          {
            name: 'Custom Analytics',
            path: '/custom_analytics',
            icon: 'bar-chart',
            authority: ['88888', 'amanda.figliolini@bms.com'],
            routes: [
              {
                path: '/custom_analytics',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__customAnalytics__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/customAnalytics/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../customAnalytics/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../customAnalytics/list').default,
                exact: true,
              },
            ],
          },
          {
            name: 'CAT',
            path: '/comparative_analysis',
            icon: 'line-chart',
            authority: ['9999', '1111', '3333', '7777'],
            routes: [
              {
                path: '/comparative_analysis',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__comparativeAnalysis__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/comparativeAnalysis/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../comparativeAnalysis/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../comparativeAnalysis/list').default,
                exact: true,
              },
            ],
          },
          {
            name: 'sites',
            path: '/sites',
            icon: 'global',
            authority: ['9999', '1111', '6666', '1', '3333', '7777', '88888'],
            routes: [
              {
                path: '/sites',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__sites__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/sites/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../sites/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../sites/list').default,
                exact: true,
              },
              {
                path: '/sites/:id',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__sites__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/sites/details/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../sites/details'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../sites/details').default,
                exact: true,
              },
            ],
          },
          {
            name: 'companyProfile',
            path: '/companyProfile',
            icon: 'bank',
            authority: ['9999', '1111', '6666', '1', '3333', '7777', '88888'],
            routes: [
              {
                path: '/companyProfile',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__companyprofile__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/companyprofile/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../companyprofile/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../companyprofile/list').default,
                exact: true,
              },
              {
                path: '/companyProfile/organization/:id',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__organization__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/organization/details/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../organization/details'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../organization/details').default,
                exact: true,
              },
              {
                path: '/companyProfile/:id',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__companyprofile__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/companyprofile/details/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../companyprofile/details'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../companyprofile/details').default,
                exact: true,
              },
            ],
          },
          {
            name: 'observations',
            path: '/observations',
            icon: 'search',
            authority: ['9999', '1111', '6666', '1', '3333', '7777', '88888'],
            routes: [
              {
                name: 'observations',
                path: '/observations/advanced',
                authority: ['9999', '1111', '6666', '1', '3333', '7777'],
                icon: 'reconciliation',
                hideInMenu: false,
                routes: [
                  {
                    path: '/observations/advanced',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__observations__searchOptions__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/observations/searchOptions/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../observations/searchOptions'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../observations/searchOptions').default,
                    exact: true,
                  },
                  {
                    path: '/observations/advanced/results',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__observations__searchResults__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/observations/searchResults/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../observations/searchResults'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../observations/searchResults').default,
                    exact: true,
                  },
                ],
              },
              {
                name: 'observationsQS',
                path: '/observations/observationsQS',
                icon: 'reconciliation',
                authority: ['9999', '1111', '6666', '3333', '7777'],
                routes: [
                  {
                    path: '/observations/observationsQS',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__observationsQS__searchOptionsQualitySystem__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/observationsQS/searchOptionsQualitySystem/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../observationsQS/searchOptionsQualitySystem'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../observationsQS/searchOptionsQualitySystem')
                          .default,
                    exact: true,
                  },
                  {
                    path: '/observations/observationsQS/results',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__observationsQS__searchResults__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/observationsQS/searchResults/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../observationsQS/searchResults'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../observationsQS/searchResults').default,
                    exact: true,
                  },
                ],
              },
              {
                name: 'observationsFTS',
                path: '/observations/freeText',
                icon: 'file-search',
                authority: ['9999', '1111', '6666', '1', '3333', '7777'],
                routes: [
                  {
                    path: '/observations/freeText',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__freeText__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/freeText/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../freeText'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../freeText').default,
                    exact: true,
                  },
                ],
              },
              {
                name: 'observationsCS',
                path: '/observations/citationSearch',
                icon: 'security-scan',
                authority: ['9999', '1111', '6666', '1', '3333', '7777'],
                routes: [
                  {
                    path: '/observations/citationSearch',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__citations__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/citations/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../citations'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../citations').default,
                    exact: true,
                  },
                ],
              },
              {
                name: 'observationsISO',
                path: '/observations/isoSearch',
                icon: 'experiment',
                authority: ['9999', '1111', '6666', '1', '3333', '7777'],
                routes: [
                  {
                    path: '/observations/isoSearch',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__isoSearch__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/isoSearch/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../isoSearch'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../isoSearch').default,
                    exact: true,
                  },
                ],
              },
              {
                name: 'Observation Intelligence',
                path: '/observations/agent',
                icon: 'robot',
                authority: ['88888'],
                routes: [
                  {
                    path: '/observations/agent',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../observationAgent'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../observationAgent').default,
                    exact: true,
                  },
                ],
              },
              {
                name: 'Saved Observation Search',
                path: '/observations/savedSearch',
                icon: 'save',
                authority: [
                  'creyes15@its.jnj.com',
                  'jboric@its.jnj.com',
                  'bhavish@codecarbonhq.com',
                  'deepak@fdalytics.com',
                ],
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../observations/savedSearch'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../observations/savedSearch').default,
                exact: true,
              },
            ],
          },
          {
            name: 'enforcement_actions',
            path: '/enforcement',
            icon: 'audit',
            authority: ['9999', '1111', '6666', '1', '3333', '7777'],
            routes: [
              {
                name: 'warning-letters',
                path: '/enforcement/warning-letters',
                icon: 'file-text',
                authority: ['9999', '1111', '6666', '1', '3333', '7777'],
                routes: [
                  {
                    path: '/enforcement/warning-letters',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__warningLetters__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/warningLetters/list/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../warningLetters/list'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../warningLetters/list').default,
                    exact: true,
                  },
                  {
                    path: '/enforcement/warning-letters/:id',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__warningLetters__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/warningLetters/details/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../warningLetters/details'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../warningLetters/details').default,
                    exact: true,
                  },
                ],
              },
              {
                name: 'Import Alerts',
                path: '/enforcement/import_alerts',
                icon: 'alert',
                authority: ['9999', '1111', '6666', '3333', '7777'],
                routes: [
                  {
                    path: '/enforcement/import_alerts',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__importAlerts__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/importAlerts/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../importAlerts'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../importAlerts').default,
                    exact: true,
                  },
                ],
              },
              {
                name: 'Recall Data',
                path: '/enforcement/recall',
                icon: 'undo',
                authority: ['9999', '1111', '6666', '1', '3333', '7777'],
                routes: [
                  {
                    path: '/enforcement/recall',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__recall__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/recall/list/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../recall/list'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../recall/list').default,
                    exact: true,
                  },
                ],
              },
              {
                name: 'Fda Debarment',
                path: '/enforcement/fda_debarment',
                icon: 'stop',
                authority: ['9999', '1111', '6666', '1', '3333', '7777'],
                routes: [
                  {
                    path: '/enforcement/fda_debarment',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__fda_debarment__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/fda_debarment/list/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../fda_debarment/list'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../fda_debarment/list').default,
                    exact: true,
                  },
                ],
              },
            ],
          },
          {
            name: 'MeDeusa',
            path: '/medical_devices',
            icon: 'radar-chart',
            authority: ['1111', '3333', '7777', '88888'],
            routes: [
              {
                name: 'Device Hub',
                path: '/medical_devices/hub',
                icon: 'cluster',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../medicalDevice/hub/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../medicalDevice/hub/list').default,
                authority: ['88888'],
                exact: true,
              },
              {
                path: '/medical_devices/hub/:device_dbid',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../medicalDevice/hub/detail'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../medicalDevice/hub/detail').default,
                authority: ['88888'],
                exact: true,
                layout: false,
              },
              {
                name: 'MyProfile',
                path: '/medical_devices/MyProfile',
                icon: 'user',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__medicalDevice__myProfile__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/medicalDevice/myProfile/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../medicalDevice/myProfile'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../medicalDevice/myProfile').default,
                exact: true,
              },
              {
                path: '/medical_devices/site/:id',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__medicalDevice__site__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/medicalDevice/site/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../medicalDevice/site'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../medicalDevice/site').default,
                exact: true,
                layout: false,
              },
              {
                name: 'Recall',
                path: '/medical_devices/recalls',
                icon: 'undo',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__medicalDevice__recalls__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/medicalDevice/recalls/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../medicalDevice/recalls/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../medicalDevice/recalls/list').default,
                exact: true,
              },
              {
                name: 'FDA 510(k)',
                path: '/medical_devices/fda_510k',
                icon: 'project',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__fda_510k__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/fda_510k/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../fda_510k/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../fda_510k/list').default,
                exact: true,
              },
              {
                name: 'New FDA 510(k)',
                path: '/medical_devices/new_fda_510k',
                icon: 'experiment',
                authority: ['88888'],
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../new_fda_510k/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../new_fda_510k/list').default,
                exact: true,
              },
              {
                name: 'MAUDE',
                path: '/medical_devices/maude',
                icon: 'warning',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__medicalDevice__maude__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/medicalDevice/maude/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../medicalDevice/maude/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../medicalDevice/maude/list').default,
                exact: true,
              },
              {
                name: 'Registration_listing',
                path: '/medical_devices/registration_listing',
                icon: 'form',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__medicalDevice__medicalDeviceRegistrationSearch__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/medicalDevice/medicalDeviceRegistrationSearch/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../medicalDevice/medicalDeviceRegistrationSearch/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../medicalDevice/medicalDeviceRegistrationSearch/list')
                      .default,
                exact: true,
              },
            ],
          },
          {
            name: 'drugAnalytics',
            path: '/drugAnalytics',
            icon: 'number',
            authority: ['9999', '1111', '6666', '1', '3333', '7777'],
            routes: [
              {
                path: '/drugAnalytics',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__druganalytics__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/druganalytics/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../druganalytics/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../druganalytics/list').default,
                exact: true,
              },
              {
                path: '/drugAnalytics/:id',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__druganalytics__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/druganalytics/details/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../druganalytics/details'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../druganalytics/details').default,
                exact: true,
              },
            ],
          },
          {
            path: '/ndc',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__ndc__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/ndc/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__ndc__list" */ '../ndc/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../ndc/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/ndc/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__ndc__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/ndc/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__ndc__details" */ '../ndc/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../ndc/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/orange_book',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__orange_book__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/orange_book/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__orange_book__list" */ '../orange_book/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../orange_book/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/orange_book/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__orange_book__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/orange_book/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__orange_book__details" */ '../orange_book/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../orange_book/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/ema_medicines',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__ema_medicines__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/ema_medicines/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__ema_medicines__list" */ '../ema_medicines/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../ema_medicines/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/ema_medicines/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__ema_medicines__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/ema_medicines/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__ema_medicines__details" */ '../ema_medicines/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../ema_medicines/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/ema_post',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__ema_medicines__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/ema_medicines/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__ema_medicines__list" */ '../ema_medicines/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../ema_medicines/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/ema_post/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__ema_post__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/ema_post/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__ema_post__details" */ '../ema_post/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../ema_post/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/ema_pip',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__ema_medicines__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/ema_medicines/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__ema_medicines__list" */ '../ema_medicines/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../ema_medicines/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/ema_pip/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__ema_pip__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/ema_pip/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__ema_pip__details" */ '../ema_pip/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../ema_pip/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/ema_outside',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__ema_medicines__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/ema_medicines/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__ema_medicines__list" */ '../ema_medicines/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../ema_medicines/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/ema_outside/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__ema_outside__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/ema_outside/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__ema_outside__details" */ '../ema_outside/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../ema_outside/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/ema_shortages',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__ema_medicines__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/ema_medicines/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__ema_medicines__list" */ '../ema_medicines/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../ema_medicines/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/ema_shortages/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__ema_shortages__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/ema_shortages/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__ema_shortages__details" */ '../ema_shortages/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../ema_shortages/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/article57',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__article57__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/article57/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__article57__list" */ '../article57/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../article57/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/cdsco',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__cdsco__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/cdsco/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__cdsco__list" */ '../cdsco/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../cdsco/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/hc_dpd',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__hc_dpd__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/hc_dpd/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__hc_dpd__list" */ '../hc_dpd/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../hc_dpd/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/hc_dpd/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__hc_dpd__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/hc_dpd/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__hc_dpd__details" */ '../hc_dpd/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../hc_dpd/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/pmda_mf',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__pmda_mf__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/pmda_mf/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__pmda_mf__list" */ '../pmda_mf/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../pmda_mf/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/pmda_mf/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__pmda_mf__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/pmda_mf/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__pmda_mf__details" */ '../pmda_mf/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../pmda_mf/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/pmda_approved_products',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__pmda_approved_products__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/pmda_approved_products/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__pmda_approved_products__list" */ '../pmda_approved_products/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../pmda_approved_products/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/pmda_approved_products/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__pmda_approved_products__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/pmda_approved_products/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__pmda_approved_products__details" */ '../pmda_approved_products/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../pmda_approved_products/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/cde_material',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__cde_material__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/cde_material/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__cde_material__list" */ '../cde_material/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../cde_material/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/cde_material/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__cde_material__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/cde_material/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__cde_material__details" */ '../cde_material/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../cde_material/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/aemps_cima',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__aemps_cima__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/aemps_cima/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__aemps_cima__list" */ '../aemps_cima/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../aemps_cima/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/aemps_cima/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__aemps_cima__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/aemps_cima/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__aemps_cima__details" */ '../aemps_cima/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../aemps_cima/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/new_zealand_medicines',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__new_zealand_medicines__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/new_zealand_medicines/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__new_zealand_medicines__list" */ '../new_zealand_medicines/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../new_zealand_medicines/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/new_zealand_medicines/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__new_zealand_medicines__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/new_zealand_medicines/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__new_zealand_medicines__details" */ '../new_zealand_medicines/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../new_zealand_medicines/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/company_360',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__company_360__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/company_360/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__company_360" */ '../company_360'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../company_360').default,
            exact: true,
            hideInMenu: true,
          },
          {
            name: 'Clinical Trials',
            path: '/clinical_trials',
            icon: 'experiment',
            authority: ['88888'],
            routes: [
              {
                path: '/clinical_trials',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__clinical_trials__search__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/clinical_trials/search/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../clinical_trials/search'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../clinical_trials/search').default,
                exact: true,
              },
              {
                path: '/clinical_trials/companies/:id',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../clinical_trials/companyDetail'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../clinical_trials/companyDetail').default,
                exact: true,
                hideInMenu: true,
              },
              {
                path: '/clinical_trials/molecules/:id',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../clinical_trials/moleculeDetail'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../clinical_trials/moleculeDetail').default,
                exact: true,
                hideInMenu: true,
              },
              {
                path: '/clinical_trials/trials/:nctId',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../clinical_trials/trialDetail'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../clinical_trials/trialDetail').default,
                exact: true,
                hideInMenu: true,
              },
              {
                path: '/clinical_trials/conditions/:id',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../clinical_trials/conditionDetail'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../clinical_trials/conditionDetail').default,
                exact: true,
                hideInMenu: true,
              },
            ],
          },
          {
            path: '/product_360',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__product_360__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/product_360/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__product_360" */ '../product_360'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../product_360').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/edqm_cep',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__edqm_cep__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/edqm_cep/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__edqm_cep__list" */ '../edqm_cep/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../edqm_cep/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/edqm_cep/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__edqm_cep__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/edqm_cep/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__edqm_cep__details" */ '../edqm_cep/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../edqm_cep/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/mfds_dmf',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__mfds_dmf__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/mfds_dmf/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__mfds_dmf__list" */ '../mfds_dmf/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../mfds_dmf/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/mfds_dmf/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__mfds_dmf__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/mfds_dmf/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__mfds_dmf__details" */ '../mfds_dmf/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../mfds_dmf/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/sfda',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__sfda__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/sfda/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__sfda__list" */ '../sfda/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../sfda/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/sfda/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__sfda__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/sfda/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__sfda__details" */ '../sfda/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../sfda/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/ogyei',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__ogyei__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/ogyei/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__ogyei__list" */ '../ogyei/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../ogyei/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/ogyei/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__ogyei__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/ogyei/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__ogyei__details" */ '../ogyei/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../ogyei/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/grls',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__grls__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/grls/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__grls__list" */ '../grls/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../grls/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/grls/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__grls__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/grls/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__grls__details" */ '../grls/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../grls/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/anvisa',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__anvisa__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/anvisa/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__anvisa__list" */ '../anvisa/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../anvisa/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/anvisa/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__anvisa__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/anvisa/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__anvisa__details" */ '../anvisa/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../anvisa/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/moph_lb',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__moph_lb__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/moph_lb/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__moph_lb__list" */ '../moph_lb/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../moph_lb/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/moph_lb/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__moph_lb__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/moph_lb/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__moph_lb__details" */ '../moph_lb/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../moph_lb/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/famhp_be',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__famhp_be__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/famhp_be/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__famhp_be__list" */ '../famhp_be/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../famhp_be/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/famhp_be/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__famhp_be__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/famhp_be/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__famhp_be__details" */ '../famhp_be/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../famhp_be/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/bdpm_fr',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__bdpm_fr__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/bdpm_fr/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__bdpm_fr__list" */ '../bdpm_fr/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../bdpm_fr/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/bdpm_fr/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__bdpm_fr__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/bdpm_fr/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__bdpm_fr__details" */ '../bdpm_fr/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../bdpm_fr/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/cdsco_drugs',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__cdsco_drugs__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/cdsco_drugs/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__cdsco_drugs__list" */ '../cdsco_drugs/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../cdsco_drugs/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/cdsco_drugs/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__cdsco_drugs__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/cdsco_drugs/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__cdsco_drugs__details" */ '../cdsco_drugs/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../cdsco_drugs/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/fimea_fi',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__fimea_fi__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/fimea_fi/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__fimea_fi__list" */ '../fimea_fi/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../fimea_fi/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/fimea_fi/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__fimea_fi__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/fimea_fi/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__fimea_fi__details" */ '../fimea_fi/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../fimea_fi/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/agemed_bo',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__agemed_bo__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/agemed_bo/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__agemed_bo__list" */ '../agemed_bo/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../agemed_bo/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/agemed_bo/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__agemed_bo__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/agemed_bo/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__agemed_bo__details" */ '../agemed_bo/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../agemed_bo/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/msp_do',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__msp_do__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/msp_do/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__msp_do__list" */ '../msp_do/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../msp_do/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/msp_do/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__msp_do__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/msp_do/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__msp_do__details" */ '../msp_do/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../msp_do/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/tga',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__tga__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/tga/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__tga__list" */ '../tga/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../tga/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/tga/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__tga__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/tga/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__tga__details" */ '../tga/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../tga/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/digemid_pe',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__digemid_pe__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/digemid_pe/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__digemid_pe__list" */ '../digemid_pe/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../digemid_pe/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/digemid_pe/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__digemid_pe__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/digemid_pe/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__digemid_pe__details" */ '../digemid_pe/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../digemid_pe/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/swissmedic_ch',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__swissmedic_ch__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/swissmedic_ch/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__swissmedic_ch__list" */ '../swissmedic_ch/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../swissmedic_ch/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/swissmedic_ch/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__swissmedic_ch__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/swissmedic_ch/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__swissmedic_ch__details" */ '../swissmedic_ch/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../swissmedic_ch/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/serlyfjaskra_is',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__serlyfjaskra_is__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/serlyfjaskra_is/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__serlyfjaskra_is__list" */ '../serlyfjaskra_is/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../serlyfjaskra_is/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/serlyfjaskra_is/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__serlyfjaskra_is__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/serlyfjaskra_is/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__serlyfjaskra_is__details" */ '../serlyfjaskra_is/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../serlyfjaskra_is/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/eof_gr',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__eof_gr__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/eof_gr/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__eof_gr__list" */ '../eof_gr/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../eof_gr/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/eof_gr/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__eof_gr__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/eof_gr/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__eof_gr__details" */ '../eof_gr/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../eof_gr/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/eudra_apireg',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__eudra_apireg__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/eudra_apireg/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__eudra_apireg__list" */ '../eudra_apireg/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../eudra_apireg/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/eudra_apireg/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__eudra_apireg__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/eudra_apireg/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__eudra_apireg__details" */ '../eudra_apireg/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../eudra_apireg/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/moh_il',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__moh_il__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/moh_il/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__moh_il__list" */ '../moh_il/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../moh_il/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/moh_il/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__moh_il__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/moh_il/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__moh_il__details" */ '../moh_il/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../moh_il/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/mma_mt',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__mma_mt__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/mma_mt/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__mma_mt__list" */ '../mma_mt/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../mma_mt/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/mma_mt/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__mma_mt__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/mma_mt/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__mma_mt__details" */ '../mma_mt/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../mma_mt/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/vademecum',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__vademecum__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/vademecum/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__vademecum__list" */ '../vademecum/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../vademecum/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/vademecum/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__vademecum__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/vademecum/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__vademecum__details" */ '../vademecum/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../vademecum/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/rpl_pl',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__rpl_pl__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/rpl_pl/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__rpl_pl__list" */ '../rpl_pl/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../rpl_pl/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/rpl_pl/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__rpl_pl__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/rpl_pl/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__rpl_pl__details" */ '../rpl_pl/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../rpl_pl/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/eda_eg',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__eda_eg__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/eda_eg/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__eda_eg__list" */ '../eda_eg/list'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../eda_eg/list').default,
            exact: true,
            hideInMenu: true,
          },
          {
            path: '/eda_eg/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__eda_eg__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/eda_eg/details/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__eda_eg__details" */ '../eda_eg/details'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../eda_eg/details').default,
            exact: true,
            hideInMenu: true,
          },
          {
            name: 'Omni',
            path: '/omni',
            icon: 'cluster',
            authority: [
              '88888',
              'bhavish@codecarbonhq.com',
              'kavita@codecarbonhq.com',
              'deepak@fdalytics.com',
              'cvicent3@its.jnj.com',
            ],
            routes: [
              {
                path: '/omni',
                redirect: '/omni/drug_dashboard/usfda/ndc',
                exact: true,
              },
              {
                name: 'Product Intelligence',
                path: '/omni/product_intelligence',
                icon: 'cluster',
                authority: [
                  '88888',
                  'bhavish@codecarbonhq.com',
                  'kavita@codecarbonhq.com',
                  'deepak@fdalytics.com',
                  'cvicent3@its.jnj.com',
                ],
                routes: [
                  {
                    path: '/omni/product_intelligence',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__api_intelligence__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/api_intelligence/list/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../api_intelligence/list'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../api_intelligence/list').default,
                    exact: true,
                  },
                  {
                    path: '/omni/product_intelligence/:apiId',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../api_intelligence/details'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../api_intelligence/details').default,
                    exact: true,
                  },
                ],
              },
              {
                name: 'Product Watchlist',
                path: '/omni/product_watchlist',
                icon: 'eye',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../product_watchlist'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../product_watchlist').default,
                authority: [
                  '88888',
                  'bhavish@codecarbonhq.com',
                  'kavita@codecarbonhq.com',
                  'deepak@fdalytics.com',
                  'cvicent3@its.jnj.com',
                ],
                exact: true,
              },
              {
                name: 'Drug Change Log',
                path: '/omni/drug_change_log',
                icon: 'audit',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../drug_change_log'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../drug_change_log').default,
                authority: ['88888', 'bhavish@codecarbonhq.com'],
                exact: true,
              },
              {
                name: 'Drug Database',
                path: '/omni/drug_dashboard',
                icon: 'medicine-box',
                authority: [
                  '88888',
                  'bhavish@codecarbonhq.com',
                  'kavita@codecarbonhq.com',
                  'deepak@fdalytics.com',
                  'cvicent3@its.jnj.com',
                ],
                routes: [
                  {
                    path: '/omni/drug_dashboard',
                    redirect: '/omni/drug_dashboard/usfda/ndc',
                    exact: true,
                  },
                  {
                    name: 'USFDA',
                    path: '/omni/drug_dashboard/usfda',
                    icon: 'bank',
                    authority: [
                      '88888',
                      'bhavish@codecarbonhq.com',
                      'kavita@codecarbonhq.com',
                      'deepak@fdalytics.com',
                      'cvicent3@its.jnj.com',
                    ],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/usfda',
                        redirect: '/omni/drug_dashboard/usfda/ndc',
                        exact: true,
                      },
                      {
                        name: 'NDC',
                        path: '/omni/drug_dashboard/usfda/ndc',
                        icon: 'medicine-box',
                        authority: [
                          '88888',
                          'bhavish@codecarbonhq.com',
                          'kavita@codecarbonhq.com',
                          'deepak@fdalytics.com',
                          'cvicent3@its.jnj.com',
                        ],
                        routes: [
                          {
                            path: '/omni/drug_dashboard/usfda/ndc',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  app: require('@tmp/dva').getApp(),
                                  models: () => [
                                    import(/* webpackChunkName: 'p__ndc__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/ndc/list/model.ts').then(
                                      m => {
                                        return {
                                          namespace: 'model',
                                          ...m.default,
                                        };
                                      },
                                    ),
                                  ],
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../ndc/list'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../ndc/list').default,
                            exact: true,
                          },
                          {
                            path: '/omni/drug_dashboard/usfda/ndc/:id',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  app: require('@tmp/dva').getApp(),
                                  models: () => [
                                    import(/* webpackChunkName: 'p__ndc__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/ndc/details/model.ts').then(
                                      m => {
                                        return {
                                          namespace: 'model',
                                          ...m.default,
                                        };
                                      },
                                    ),
                                  ],
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../ndc/details'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../ndc/details').default,
                            exact: true,
                          },
                        ],
                      },
                      {
                        name: 'FDA Orange Book',
                        path: '/omni/drug_dashboard/usfda/orange_book',
                        icon: 'file-text',
                        authority: [
                          '88888',
                          'bhavish@codecarbonhq.com',
                          'kavita@codecarbonhq.com',
                          'deepak@fdalytics.com',
                          'cvicent3@its.jnj.com',
                        ],
                        routes: [
                          {
                            path: '/omni/drug_dashboard/usfda/orange_book',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  app: require('@tmp/dva').getApp(),
                                  models: () => [
                                    import(/* webpackChunkName: 'p__orange_book__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/orange_book/list/model.ts').then(
                                      m => {
                                        return {
                                          namespace: 'model',
                                          ...m.default,
                                        };
                                      },
                                    ),
                                  ],
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../orange_book/list'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../orange_book/list').default,
                            exact: true,
                          },
                          {
                            path: '/omni/drug_dashboard/usfda/orange_book/:id',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  app: require('@tmp/dva').getApp(),
                                  models: () => [
                                    import(/* webpackChunkName: 'p__orange_book__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/orange_book/details/model.ts').then(
                                      m => {
                                        return {
                                          namespace: 'model',
                                          ...m.default,
                                        };
                                      },
                                    ),
                                  ],
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../orange_book/details'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../orange_book/details').default,
                            exact: true,
                          },
                        ],
                      },
                      {
                        name: 'FDA Purple Book',
                        path: '/omni/drug_dashboard/usfda/purple_book',
                        icon: 'experiment',
                        authority: [
                          '88888',
                          'bhavish@codecarbonhq.com',
                          'kavita@codecarbonhq.com',
                          'deepak@fdalytics.com',
                          'cvicent3@its.jnj.com',
                        ],
                        routes: [
                          {
                            path: '/omni/drug_dashboard/usfda/purple_book',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  app: require('@tmp/dva').getApp(),
                                  models: () => [
                                    import(/* webpackChunkName: 'p__purple_book__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/purple_book/list/model.ts').then(
                                      m => {
                                        return {
                                          namespace: 'model',
                                          ...m.default,
                                        };
                                      },
                                    ),
                                  ],
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../purple_book/list'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../purple_book/list').default,
                            exact: true,
                          },
                          {
                            path: '/omni/drug_dashboard/usfda/purple_book/:id',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../purple_book/details'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../purple_book/details').default,
                            exact: true,
                          },
                        ],
                      },
                      {
                        name: 'DMF Search',
                        path: '/omni/drug_dashboard/usfda/dmf',
                        icon: 'experiment',
                        authority: [
                          '88888',
                          'bhavish@codecarbonhq.com',
                          'kavita@codecarbonhq.com',
                          'deepak@fdalytics.com',
                          'cvicent3@its.jnj.com',
                        ],
                        routes: [
                          {
                            path: '/omni/drug_dashboard/usfda/dmf',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../dmf_search'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../dmf_search').default,
                            exact: true,
                          },
                        ],
                      },
                      {
                        name: 'Drug Shortages',
                        path: '/omni/drug_dashboard/usfda/drug_shortages',
                        icon: 'alert',
                        authority: [
                          '88888',
                          'bhavish@codecarbonhq.com',
                          'kavita@codecarbonhq.com',
                          'deepak@fdalytics.com',
                          'cvicent3@its.jnj.com',
                        ],
                        routes: [
                          {
                            path: '/omni/drug_dashboard/usfda/drug_shortages',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../usfda_shortages/list'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../usfda_shortages/list').default,
                            exact: true,
                          },
                          {
                            path:
                              '/omni/drug_dashboard/usfda/drug_shortages/:id',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../usfda_shortages/details'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../usfda_shortages/details').default,
                            exact: true,
                          },
                        ],
                      },
                      {
                        path: '/omni/drug_dashboard/usfda/user_fees',
                        redirect: '/user_fees',
                        exact: true,
                        hideInMenu: true,
                      },
                      {
                        path: '/omni/drug_dashboard/usfda/api',
                        redirect: '/omni/product_intelligence',
                        exact: true,
                        hideInMenu: true,
                      },
                      {
                        path: '/omni/drug_dashboard/usfda/api/:apiId',
                        redirect: '/omni/product_intelligence/:apiId',
                        exact: true,
                        hideInMenu: true,
                      },
                    ],
                  },
                  {
                    name: 'EMA',
                    path: '/omni/drug_dashboard/ema',
                    icon: 'global',
                    authority: [
                      '88888',
                      'bhavish@codecarbonhq.com',
                      'kavita@codecarbonhq.com',
                      'deepak@fdalytics.com',
                      'cvicent3@its.jnj.com',
                    ],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/ema',
                        redirect: '/omni/drug_dashboard/ema/ema_medicines',
                        exact: true,
                      },
                      {
                        name: 'EMA Medicines',
                        path: '/omni/drug_dashboard/ema/ema_medicines',
                        icon: 'medicine-box',
                        authority: [
                          '88888',
                          'bhavish@codecarbonhq.com',
                          'kavita@codecarbonhq.com',
                          'deepak@fdalytics.com',
                        ],
                        routes: [
                          {
                            path: '/omni/drug_dashboard/ema/ema_medicines',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  app: require('@tmp/dva').getApp(),
                                  models: () => [
                                    import(/* webpackChunkName: 'p__ema_medicines__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/ema_medicines/list/model.ts').then(
                                      m => {
                                        return {
                                          namespace: 'model',
                                          ...m.default,
                                        };
                                      },
                                    ),
                                  ],
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../ema_medicines/list'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../ema_medicines/list').default,
                            exact: true,
                          },
                          {
                            path: '/omni/drug_dashboard/ema/ema_medicines/:id',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  app: require('@tmp/dva').getApp(),
                                  models: () => [
                                    import(/* webpackChunkName: 'p__ema_medicines__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/ema_medicines/details/model.ts').then(
                                      m => {
                                        return {
                                          namespace: 'model',
                                          ...m.default,
                                        };
                                      },
                                    ),
                                  ],
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../ema_medicines/details'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../ema_medicines/details').default,
                            exact: true,
                          },
                        ],
                      },
                      {
                        name: 'EudraGMDP API Reg',
                        path: '/omni/drug_dashboard/ema/eudra_apireg',
                        icon: 'security-scan',
                        authority: [
                          '88888',
                          'bhavish@codecarbonhq.com',
                          'kavita@codecarbonhq.com',
                          'deepak@fdalytics.com',
                          'cvicent3@its.jnj.com',
                        ],
                        routes: [
                          {
                            path: '/omni/drug_dashboard/ema/eudra_apireg',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  app: require('@tmp/dva').getApp(),
                                  models: () => [
                                    import(/* webpackChunkName: 'p__eudra_apireg__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/eudra_apireg/list/model.ts').then(
                                      m => {
                                        return {
                                          namespace: 'model',
                                          ...m.default,
                                        };
                                      },
                                    ),
                                  ],
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../eudra_apireg/list'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../eudra_apireg/list').default,
                            exact: true,
                          },
                          {
                            path: '/omni/drug_dashboard/ema/eudra_apireg/:id',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  app: require('@tmp/dva').getApp(),
                                  models: () => [
                                    import(/* webpackChunkName: 'p__eudra_apireg__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/eudra_apireg/details/model.ts').then(
                                      m => {
                                        return {
                                          namespace: 'model',
                                          ...m.default,
                                        };
                                      },
                                    ),
                                  ],
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../eudra_apireg/details'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../eudra_apireg/details').default,
                            exact: true,
                          },
                        ],
                      },
                      {
                        name: 'Article 57 Products',
                        path: '/omni/drug_dashboard/ema/article57',
                        icon: 'file-text',
                        authority: ['88888', 'bhavish@codecarbonhq.com'],
                        routes: [
                          {
                            path: '/omni/drug_dashboard/ema/article57',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  app: require('@tmp/dva').getApp(),
                                  models: () => [
                                    import(/* webpackChunkName: 'p__article57__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/article57/list/model.ts').then(
                                      m => {
                                        return {
                                          namespace: 'model',
                                          ...m.default,
                                        };
                                      },
                                    ),
                                  ],
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../article57/list'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../article57/list').default,
                            exact: true,
                          },
                        ],
                      },
                      {
                        name: 'EMA Shortages',
                        path: '/omni/drug_dashboard/ema/ema_shortages',
                        icon: 'alert',
                        authority: [
                          '88888',
                          'bhavish@codecarbonhq.com',
                          'kavita@codecarbonhq.com',
                          'deepak@fdalytics.com',
                          'cvicent3@its.jnj.com',
                        ],
                        routes: [
                          {
                            path: '/omni/drug_dashboard/ema/ema_shortages',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  app: require('@tmp/dva').getApp(),
                                  models: () => [
                                    import(/* webpackChunkName: 'p__ema_medicines__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/ema_medicines/list/model.ts').then(
                                      m => {
                                        return {
                                          namespace: 'model',
                                          ...m.default,
                                        };
                                      },
                                    ),
                                  ],
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../ema_medicines/list'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../ema_medicines/list').default,
                            exact: true,
                          },
                          {
                            path: '/omni/drug_dashboard/ema/ema_shortages/:id',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  app: require('@tmp/dva').getApp(),
                                  models: () => [
                                    import(/* webpackChunkName: 'p__ema_shortages__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/ema_shortages/details/model.ts').then(
                                      m => {
                                        return {
                                          namespace: 'model',
                                          ...m.default,
                                        };
                                      },
                                    ),
                                  ],
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../ema_shortages/details'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../ema_shortages/details').default,
                            exact: true,
                          },
                        ],
                      },
                    ],
                  },
                  {
                    name: 'CDSCO Written Confirmations',
                    path: '/omni/drug_dashboard/cdsco',
                    icon: 'audit',
                    authority: [
                      '88888',
                      'bhavish@codecarbonhq.com',
                      'kavita@codecarbonhq.com',
                      'deepak@fdalytics.com',
                      'cvicent3@its.jnj.com',
                    ],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/cdsco',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__cdsco__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/cdsco/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../cdsco/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../cdsco/list').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'Health Canada DPD',
                    path: '/omni/drug_dashboard/hc_dpd',
                    icon: 'medicine-box',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/hc_dpd',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__hc_dpd__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/hc_dpd/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../hc_dpd/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../hc_dpd/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/hc_dpd/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__hc_dpd__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/hc_dpd/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../hc_dpd/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../hc_dpd/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'PMDA',
                    path: '/omni/drug_dashboard/pmda',
                    icon: 'global',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/pmda',
                        redirect: '/omni/drug_dashboard/pmda/pmda_mf',
                        exact: true,
                      },
                      {
                        name: 'PMDA MF Register',
                        path: '/omni/drug_dashboard/pmda/pmda_mf',
                        icon: 'reconciliation',
                        authority: ['88888', 'bhavish@codecarbonhq.com'],
                        routes: [
                          {
                            path: '/omni/drug_dashboard/pmda/pmda_mf',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  app: require('@tmp/dva').getApp(),
                                  models: () => [
                                    import(/* webpackChunkName: 'p__pmda_mf__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/pmda_mf/list/model.ts').then(
                                      m => {
                                        return {
                                          namespace: 'model',
                                          ...m.default,
                                        };
                                      },
                                    ),
                                  ],
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../pmda_mf/list'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../pmda_mf/list').default,
                            exact: true,
                          },
                          {
                            path: '/omni/drug_dashboard/pmda/pmda_mf/:id',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  app: require('@tmp/dva').getApp(),
                                  models: () => [
                                    import(/* webpackChunkName: 'p__pmda_mf__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/pmda_mf/details/model.ts').then(
                                      m => {
                                        return {
                                          namespace: 'model',
                                          ...m.default,
                                        };
                                      },
                                    ),
                                  ],
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../pmda_mf/details'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../pmda_mf/details').default,
                            exact: true,
                          },
                        ],
                      },
                      {
                        name: 'PMDA Approved Products',
                        path:
                          '/omni/drug_dashboard/pmda/pmda_approved_products',
                        icon: 'medicine-box',
                        authority: ['88888', 'bhavish@codecarbonhq.com'],
                        routes: [
                          {
                            path:
                              '/omni/drug_dashboard/pmda/pmda_approved_products',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  app: require('@tmp/dva').getApp(),
                                  models: () => [
                                    import(/* webpackChunkName: 'p__pmda_approved_products__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/pmda_approved_products/list/model.ts').then(
                                      m => {
                                        return {
                                          namespace: 'model',
                                          ...m.default,
                                        };
                                      },
                                    ),
                                  ],
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../pmda_approved_products/list'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../pmda_approved_products/list')
                                  .default,
                            exact: true,
                          },
                          {
                            path:
                              '/omni/drug_dashboard/pmda/pmda_approved_products/:id',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  app: require('@tmp/dva').getApp(),
                                  models: () => [
                                    import(/* webpackChunkName: 'p__pmda_approved_products__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/pmda_approved_products/details/model.ts').then(
                                      m => {
                                        return {
                                          namespace: 'model',
                                          ...m.default,
                                        };
                                      },
                                    ),
                                  ],
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../pmda_approved_products/details'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../pmda_approved_products/details')
                                  .default,
                            exact: true,
                          },
                        ],
                      },
                    ],
                  },
                  {
                    name: 'CDE Material Registrations',
                    path: '/omni/drug_dashboard/cde_material',
                    icon: 'experiment',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/cde_material',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__cde_material__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/cde_material/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../cde_material/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../cde_material/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/cde_material/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__cde_material__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/cde_material/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../cde_material/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../cde_material/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'AEMPS CIMA (Spain)',
                    path: '/omni/drug_dashboard/aemps_cima',
                    icon: 'medicine-box',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/aemps_cima',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__aemps_cima__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/aemps_cima/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../aemps_cima/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../aemps_cima/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/aemps_cima/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__aemps_cima__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/aemps_cima/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../aemps_cima/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../aemps_cima/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'New Zealand',
                    path: '/omni/drug_dashboard/new_zealand',
                    icon: 'global',
                    authority: [
                      '88888',
                      'bhavish@codecarbonhq.com',
                      'kavita@codecarbonhq.com',
                      'deepak@fdalytics.com',
                      'cvicent3@its.jnj.com',
                    ],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/new_zealand',
                        redirect:
                          '/omni/drug_dashboard/new_zealand/new_zealand_medicines',
                        exact: true,
                      },
                      {
                        name: 'NZ Medicines',
                        path:
                          '/omni/drug_dashboard/new_zealand/new_zealand_medicines',
                        icon: 'medicine-box',
                        authority: [
                          '88888',
                          'bhavish@codecarbonhq.com',
                          'kavita@codecarbonhq.com',
                          'deepak@fdalytics.com',
                          'cvicent3@its.jnj.com',
                        ],
                        routes: [
                          {
                            path:
                              '/omni/drug_dashboard/new_zealand/new_zealand_medicines',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  app: require('@tmp/dva').getApp(),
                                  models: () => [
                                    import(/* webpackChunkName: 'p__new_zealand_medicines__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/new_zealand_medicines/list/model.ts').then(
                                      m => {
                                        return {
                                          namespace: 'model',
                                          ...m.default,
                                        };
                                      },
                                    ),
                                  ],
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../new_zealand_medicines/list'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../new_zealand_medicines/list')
                                  .default,
                            exact: true,
                          },
                          {
                            path:
                              '/omni/drug_dashboard/new_zealand/new_zealand_medicines/:id',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  app: require('@tmp/dva').getApp(),
                                  models: () => [
                                    import(/* webpackChunkName: 'p__new_zealand_medicines__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/new_zealand_medicines/details/model.ts').then(
                                      m => {
                                        return {
                                          namespace: 'model',
                                          ...m.default,
                                        };
                                      },
                                    ),
                                  ],
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../new_zealand_medicines/details'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../new_zealand_medicines/details')
                                  .default,
                            exact: true,
                          },
                        ],
                      },
                      {
                        name: 'NZ Shortages',
                        path: '/omni/drug_dashboard/new_zealand/nz_shortages',
                        icon: 'alert',
                        authority: [
                          '88888',
                          'bhavish@codecarbonhq.com',
                          'kavita@codecarbonhq.com',
                          'deepak@fdalytics.com',
                          'cvicent3@its.jnj.com',
                        ],
                        routes: [
                          {
                            path:
                              '/omni/drug_dashboard/new_zealand/nz_shortages',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../nz_shortages/list'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../nz_shortages/list').default,
                            exact: true,
                          },
                          {
                            path:
                              '/omni/drug_dashboard/new_zealand/nz_shortages/:id',
                            component: __IS_BROWSER
                              ? _dvaDynamic({
                                  component: () =>
                                    import(/* webpackChunkName: "layouts__BasicLayout" */ '../nz_shortages/details'),
                                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                    .default,
                                })
                              : require('../nz_shortages/details').default,
                            exact: true,
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: '/omni/drug_dashboard/new_zealand_medicines',
                    redirect:
                      '/omni/drug_dashboard/new_zealand/new_zealand_medicines',
                    exact: true,
                    hideInMenu: true,
                  },
                  {
                    path: '/omni/drug_dashboard/new_zealand_medicines/:id',
                    redirect:
                      '/omni/drug_dashboard/new_zealand/new_zealand_medicines/:id',
                    exact: true,
                    hideInMenu: true,
                  },
                  {
                    name: 'EDQM CEP',
                    path: '/omni/drug_dashboard/edqm_cep',
                    icon: 'security-scan',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/edqm_cep',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__edqm_cep__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/edqm_cep/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../edqm_cep/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../edqm_cep/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/edqm_cep/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__edqm_cep__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/edqm_cep/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../edqm_cep/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../edqm_cep/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'Korea MFDS DMF',
                    path: '/omni/drug_dashboard/mfds_dmf',
                    icon: 'reconciliation',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/mfds_dmf',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__mfds_dmf__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/mfds_dmf/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../mfds_dmf/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../mfds_dmf/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/mfds_dmf/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__mfds_dmf__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/mfds_dmf/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../mfds_dmf/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../mfds_dmf/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'Saudi Arabia SFDA',
                    path: '/omni/drug_dashboard/sfda',
                    icon: 'medicine-box',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/sfda',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__sfda__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/sfda/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../sfda/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../sfda/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/sfda/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__sfda__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/sfda/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../sfda/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../sfda/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'Hungary OGYEI',
                    path: '/omni/drug_dashboard/ogyei',
                    icon: 'medicine-box',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/ogyei',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__ogyei__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/ogyei/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../ogyei/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../ogyei/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/ogyei/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__ogyei__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/ogyei/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../ogyei/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../ogyei/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'Russia GRLS',
                    path: '/omni/drug_dashboard/grls',
                    icon: 'medicine-box',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/grls',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__grls__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/grls/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../grls/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../grls/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/grls/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__grls__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/grls/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../grls/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../grls/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'Brazil ANVISA',
                    path: '/omni/drug_dashboard/anvisa',
                    icon: 'medicine-box',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/anvisa',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__anvisa__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/anvisa/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../anvisa/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../anvisa/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/anvisa/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__anvisa__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/anvisa/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../anvisa/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../anvisa/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'Lebanon MOPH',
                    path: '/omni/drug_dashboard/moph_lb',
                    icon: 'medicine-box',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/moph_lb',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__moph_lb__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/moph_lb/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../moph_lb/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../moph_lb/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/moph_lb/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__moph_lb__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/moph_lb/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../moph_lb/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../moph_lb/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'Belgium FAMHP',
                    path: '/omni/drug_dashboard/famhp_be',
                    icon: 'medicine-box',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/famhp_be',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__famhp_be__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/famhp_be/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../famhp_be/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../famhp_be/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/famhp_be/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__famhp_be__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/famhp_be/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../famhp_be/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../famhp_be/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'France BDPM',
                    path: '/omni/drug_dashboard/bdpm_fr',
                    icon: 'medicine-box',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/bdpm_fr',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__bdpm_fr__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/bdpm_fr/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../bdpm_fr/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../bdpm_fr/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/bdpm_fr/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__bdpm_fr__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/bdpm_fr/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../bdpm_fr/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../bdpm_fr/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'India CDSCO',
                    path: '/omni/drug_dashboard/cdsco_drugs',
                    icon: 'medicine-box',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/cdsco_drugs',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__cdsco_drugs__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/cdsco_drugs/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../cdsco_drugs/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../cdsco_drugs/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/cdsco_drugs/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__cdsco_drugs__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/cdsco_drugs/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../cdsco_drugs/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../cdsco_drugs/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'Finland Fimea',
                    path: '/omni/drug_dashboard/fimea_fi',
                    icon: 'medicine-box',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/fimea_fi',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__fimea_fi__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/fimea_fi/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../fimea_fi/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../fimea_fi/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/fimea_fi/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__fimea_fi__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/fimea_fi/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../fimea_fi/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../fimea_fi/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'Bolivia AGEMED',
                    path: '/omni/drug_dashboard/agemed_bo',
                    icon: 'medicine-box',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/agemed_bo',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__agemed_bo__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/agemed_bo/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../agemed_bo/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../agemed_bo/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/agemed_bo/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__agemed_bo__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/agemed_bo/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../agemed_bo/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../agemed_bo/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'Dominican Republic MSP',
                    path: '/omni/drug_dashboard/msp_do',
                    icon: 'medicine-box',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/msp_do',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__msp_do__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/msp_do/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../msp_do/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../msp_do/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/msp_do/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__msp_do__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/msp_do/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../msp_do/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../msp_do/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'Australia TGA',
                    path: '/omni/drug_dashboard/tga',
                    icon: 'medicine-box',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/tga',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__tga__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/tga/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../tga/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../tga/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/tga/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__tga__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/tga/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../tga/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../tga/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'Peru DIGEMID',
                    path: '/omni/drug_dashboard/digemid_pe',
                    icon: 'medicine-box',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/digemid_pe',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__digemid_pe__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/digemid_pe/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../digemid_pe/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../digemid_pe/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/digemid_pe/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__digemid_pe__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/digemid_pe/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../digemid_pe/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../digemid_pe/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'Switzerland Swissmedicinfo',
                    path: '/omni/drug_dashboard/swissmedic_ch',
                    icon: 'medicine-box',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/swissmedic_ch',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__swissmedic_ch__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/swissmedic_ch/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../swissmedic_ch/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../swissmedic_ch/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/swissmedic_ch/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__swissmedic_ch__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/swissmedic_ch/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../swissmedic_ch/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../swissmedic_ch/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'Iceland Serlyfjaskra',
                    path: '/omni/drug_dashboard/serlyfjaskra_is',
                    icon: 'medicine-box',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/serlyfjaskra_is',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__serlyfjaskra_is__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/serlyfjaskra_is/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../serlyfjaskra_is/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../serlyfjaskra_is/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/serlyfjaskra_is/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__serlyfjaskra_is__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/serlyfjaskra_is/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../serlyfjaskra_is/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../serlyfjaskra_is/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'Greece EOF',
                    path: '/omni/drug_dashboard/eof_gr',
                    icon: 'medicine-box',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/eof_gr',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__eof_gr__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/eof_gr/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../eof_gr/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../eof_gr/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/eof_gr/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__eof_gr__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/eof_gr/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../eof_gr/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../eof_gr/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'Israel MOH',
                    path: '/omni/drug_dashboard/moh_il',
                    icon: 'medicine-box',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/moh_il',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__moh_il__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/moh_il/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../moh_il/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../moh_il/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/moh_il/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__moh_il__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/moh_il/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../moh_il/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../moh_il/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'Malta MMA',
                    path: '/omni/drug_dashboard/mma_mt',
                    icon: 'medicine-box',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/mma_mt',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__mma_mt__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/mma_mt/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../mma_mt/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../mma_mt/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/mma_mt/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__mma_mt__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/mma_mt/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../mma_mt/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../mma_mt/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'Vademecum',
                    path: '/omni/drug_dashboard/vademecum',
                    icon: 'medicine-box',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/vademecum',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__vademecum__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/vademecum/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../vademecum/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../vademecum/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/vademecum/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__vademecum__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/vademecum/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../vademecum/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../vademecum/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'Poland RPL',
                    path: '/omni/drug_dashboard/rpl_pl',
                    icon: 'medicine-box',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/rpl_pl',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__rpl_pl__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/rpl_pl/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../rpl_pl/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../rpl_pl/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/rpl_pl/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__rpl_pl__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/rpl_pl/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../rpl_pl/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../rpl_pl/details').default,
                        exact: true,
                      },
                    ],
                  },
                  {
                    name: 'Egypt EDA',
                    path: '/omni/drug_dashboard/eda_eg',
                    icon: 'medicine-box',
                    authority: ['88888', 'bhavish@codecarbonhq.com'],
                    routes: [
                      {
                        path: '/omni/drug_dashboard/eda_eg',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__eda_eg__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/eda_eg/list/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../eda_eg/list'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../eda_eg/list').default,
                        exact: true,
                      },
                      {
                        path: '/omni/drug_dashboard/eda_eg/:id',
                        component: __IS_BROWSER
                          ? _dvaDynamic({
                              app: require('@tmp/dva').getApp(),
                              models: () => [
                                import(/* webpackChunkName: 'p__eda_eg__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/eda_eg/details/model.ts').then(
                                  m => {
                                    return { namespace: 'model', ...m.default };
                                  },
                                ),
                              ],
                              component: () =>
                                import(/* webpackChunkName: "layouts__BasicLayout" */ '../eda_eg/details'),
                              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                                .default,
                            })
                          : require('../eda_eg/details').default,
                        exact: true,
                      },
                    ],
                  },
                ],
              },
              {
                name: 'Company 360',
                path: '/omni/company_360',
                icon: 'team',
                authority: ['88888', 'bhavish@codecarbonhq.com'],
                routes: [
                  {
                    path: '/omni/company_360',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__company_360__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/company_360/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../company_360'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../company_360').default,
                    exact: true,
                  },
                ],
              },
              {
                name: 'Product 360',
                path: '/omni/product_360',
                icon: 'experiment',
                authority: ['88888', 'bhavish@codecarbonhq.com'],
                routes: [
                  {
                    path: '/omni/product_360',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__product_360__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/product_360/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../product_360'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../product_360').default,
                    exact: true,
                  },
                ],
              },
              {
                name: 'Product Directory',
                path: '/omni/products',
                icon: 'unordered-list',
                authority: ['88888', 'bhavish@codecarbonhq.com'],
                routes: [
                  {
                    path: '/omni/products',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__products__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/products/list/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../products/list'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../products/list').default,
                    exact: true,
                  },
                  {
                    path: '/omni/products/:id',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__products__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/products/details/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../products/details'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../products/details').default,
                    exact: true,
                  },
                ],
              },
              {
                name: 'Litigation',
                path: '/omni/litigation',
                icon: 'audit',
                authority: ['88888', 'bhavish@codecarbonhq.com'],
                routes: [
                  {
                    path: '/omni/litigation',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__litigation__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/litigation/list/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../litigation/list'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../litigation/list').default,
                    exact: true,
                  },
                  {
                    path: '/omni/litigation/:id',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__litigation__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/litigation/details/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../litigation/details'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../litigation/details').default,
                    exact: true,
                  },
                ],
              },
              {
                name: 'Drug Pipeline Intelligence',
                path: '/omni/supply_chain_radar',
                icon: 'radar-chart',
                authority: ['88888', 'bhavish@codecarbonhq.com'],
                routes: [
                  {
                    path: '/omni/supply_chain_radar',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../supply_chain_radar'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../supply_chain_radar').default,
                    exact: true,
                  },
                ],
              },
            ],
          },
          {
            name: 'Watchlist Tracking',
            path: '/watchlist_tracking',
            icon: 'eye',
            authority: ['88888'],
            routes: [
              {
                path: '/watchlist_tracking',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__watchlist_tracking__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/watchlist_tracking/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../watchlist_tracking/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../watchlist_tracking/list').default,
                exact: true,
              },
            ],
          },
          {
            name: 'FOIA Requests',
            path: '/foia-requests',
            icon: 'file-search',
            authority: ['88888'],
            routes: [
              {
                path: '/foia-requests',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__foiaRequests__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/foiaRequests/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../foiaRequests/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../foiaRequests/list').default,
                exact: true,
              },
            ],
          },
          {
            name: 'Usfda User Fees',
            path: '/user_fees',
            icon: 'bank',
            authority: [
              '1111',
              '88888',
              '3333',
              '7777',
              'bhavish@codecarbonhq.com',
              'kavita@codecarbonhq.com',
              'deepak@fdalytics.com',
            ],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__user_fees" */ '../user_fees'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../user_fees').default,
            exact: true,
          },
          {
            name: 'Investigators, CROs & IRBs',
            path: '/bmis',
            icon: 'team',
            authority: ['88888'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__fda_bmis" */ '../fda_bmis'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../fda_bmis').default,
            exact: true,
          },
          {
            name: 'Supply Chain',
            path: '/supplyChain',
            icon: 'cluster',
            authority: [
              '1111',
              '88888',
              '3333',
              '7777',
              'deepak@fdalytics.com',
            ],
            routes: [
              {
                name: 'Monitoring',
                path: '/supplyChain/monitoring',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__supplyChain__monitoring__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/supplyChain/monitoring/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../supplyChain/monitoring/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../supplyChain/monitoring/list').default,
                exact: true,
                icon: 'eye',
                authority: [
                  '1111',
                  '88888',
                  '3333',
                  '7777',
                  'deepak@fdalytics.com',
                ],
              },
              {
                name: 'Supplier Profile',
                path: '/supplyChain/supplierProfile',
                icon: 'bank',
                authority: ['88888', '3333', '7777'],
                routes: [
                  {
                    path: '/supplyChain/supplierProfile',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__supplyChain__supplierProfile__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/supplyChain/supplierProfile/list/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../supplyChain/supplierProfile/list'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../supplyChain/supplierProfile/list').default,
                    exact: true,
                  },
                  {
                    path: '/supplyChain/supplierProfile/:id',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__supplyChain__supplierProfile__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/supplyChain/supplierProfile/details/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../supplyChain/supplierProfile/details'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../supplyChain/supplierProfile/details')
                          .default,
                    exact: true,
                  },
                ],
              },
              {
                name: 'Product Profile',
                path: '/supplyChain/productProfile',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__supplyChain__productProfile__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/supplyChain/productProfile/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../supplyChain/productProfile/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../supplyChain/productProfile/list').default,
                exact: true,
                icon: 'medicine-box',
                authority: ['88888'],
              },
              {
                name: 'Product Monitoring',
                path: '/supplyChain/productMonitoring',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__supplyChain__productMonitoring__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/supplyChain/productMonitoring/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../supplyChain/productMonitoring/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../supplyChain/productMonitoring/list').default,
                exact: true,
                icon: 'eye',
                authority: ['88888'],
              },
              {
                name: 'API Intelligence',
                path: '/supplyChain/apiIntelligence',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__supplyChain__apiIntelligence__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/supplyChain/apiIntelligence/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../supplyChain/apiIntelligence/index'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../supplyChain/apiIntelligence/index').default,
                exact: true,
                icon: 'apartment',
                authority: ['88888'],
              },
            ],
          },
          {
            name: 'NewsFeed',
            path: '/news_feed',
            icon: 'sound',
            authority: ['9999', '1111', '6666', '3333', '7777'],
            routes: [
              {
                path: '/news_feed',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__newsFeed__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/newsFeed/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../newsFeed/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../newsFeed/list').default,
                exact: true,
              },
            ],
          },
          {
            name: 'FdaCRLHistory',
            path: '/fda_crl',
            icon: 'sound',
            authority: ['1111', '9999', '3333', '7777'],
            routes: [
              {
                path: '/fda_crl',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__fdaCRLHistory__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/fdaCRLHistory/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../fdaCRLHistory/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../fdaCRLHistory/list').default,
                exact: true,
              },
            ],
          },
          {
            name: 'My Hub',
            path: '/myHub',
            icon: 'save',
            authority: ['1111', '9999', '6666', '3333', '7777'],
            routes: [
              {
                name: 'My WatchList',
                path: '/myHub/WatchList',
                icon: 'eye',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__watchList__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/watchList/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../watchList/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../watchList/list').default,
                authority: ['1111', '9999', '6666', '3333', '7777'],
                exact: true,
              },
              {
                name: 'My Saved Searches',
                path: '/myHub/savedSearch',
                icon: 'search',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__savedSearch__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/savedSearch/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../savedSearch/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../savedSearch/list').default,
                authority: ['1111', '9999', '3333', '7777'],
                exact: true,
              },
              {
                name: 'My Notifications',
                path: '/myHub/notifications',
                icon: 'notification',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__myNotifications__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/myNotifications/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../myNotifications/list'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../myNotifications/list').default,
                authority: ['1111', '9999', '6666', '3333', '7777'],
                exact: true,
              },
              {
                name: 'Manage Notifications',
                path: '/myHub/notifications/notifications',
                icon: 'notification',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../myNotifications/notifications'),
                      LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../myNotifications/notifications').default,
                authority: ['1111', '9999', '6666', '3333', '7777'],
                exact: true,
                hideInMenu: true,
              },
              {
                name: 'My Notes',
                path: '/myHub/notes',
                icon: 'home',
                authority: ['1111', '3333'],
                routes: [
                  {
                    path: '/myHub/notes',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__myNotes__list__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/myNotes/list/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../myNotes/list'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../myNotes/list').default,
                    exact: true,
                  },
                  {
                    path: '/myHub/notes/:id',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__myNotes__details__model.ts' */ '/home/runner/work/1/s/frontend/src/pages/myNotes/details/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../myNotes/details'),
                          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../myNotes/details').default,
                    exact: true,
                  },
                ],
              },
            ],
          },
          {
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__404" */ '../404'),
                  LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                    .default,
                })
              : require('../404').default,
            exact: true,
          },
        ],
      },
      {
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__404" */ '../404'),
              LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
                .default,
            })
          : require('../404').default,
        exact: true,
      },
    ],
  },
  {
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () => import(/* webpackChunkName: "p__404" */ '../404'),
          LoadingComponent: require('/home/runner/work/1/s/frontend/src/components/PageLoading/index')
            .default,
        })
      : require('../404').default,
    exact: true,
  },
];
window.g_routes = routes;
const plugins = require('umi/_runtimePlugin');
plugins.applyForEach('patchRoutes', { initialValue: routes });

export { routes };

export default class RouterWrapper extends React.Component {
  unListen() {}

  constructor(props) {
    super(props);

    // route change handler
    function routeChangeHandler(location, action) {
      plugins.applyForEach('onRouteChange', {
        initialValue: {
          routes,
          location,
          action,
        },
      });
    }
    this.unListen = history.listen(routeChangeHandler);
    // dva 中 history.listen 会初始执行一次
    // 这里排除掉 dva 的场景，可以避免 onRouteChange 在启用 dva 后的初始加载时被多执行一次
    const isDva =
      history.listen
        .toString()
        .indexOf('callback(history.location, history.action)') > -1;
    if (!isDva) {
      routeChangeHandler(history.location);
    }
  }

  componentWillUnmount() {
    this.unListen();
  }

  render() {
    const props = this.props || {};
    return (
      <RendererWrapper0>
        <Router history={history}>{renderRoutes(routes, props)}</Router>
      </RendererWrapper0>
    );
  }
}
